import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Modal } from 'app/design/primitives/modal';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';

export function DiscardListingChangesModal({
  open,
  onKeepEditing,
  onDiscard,
}: {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}) {
  const { t } = useTranslation('new');
  return (
    <Modal onClose={onKeepEditing} open={open} transparent>
      <Modal.Card>
        <Modal.Title allowClose onClose={onKeepEditing}>
          {t('discardChanges.title')}
        </Modal.Title>
        <Text textAlign="center">{t('discardChanges.description')}</Text>
        <Column gap="spacing.general.x2">
          <Button onPress={onKeepEditing} variant="primary">
            {t('discardChanges.keepEditing')}
          </Button>
          <Button onPress={onDiscard} variant="secondary">
            {t('discardChanges.leave')}
          </Button>
        </Column>
      </Modal.Card>
    </Modal>
  );
}
